import TagManager from 'react-gtm-module'

export const Tag = (page) => {
    if (!window.dataLayer){
        TagManager.initialize({
            gtmId: 'GTM-5ST6367Z'
        });
    }

    const tagManagerDataLayerArgs = {
        dataLayer: {
            page: page
        },
        dataLayerName: 'PageDataLayer'
    }
    TagManager.dataLayer(tagManagerDataLayerArgs)
};